import React, { useEffect, useState } from 'react';
import { Container, ContainerTitle, PDFButton, PDFButtonContainer } from './styles';
import StampContainer from './components/StampContainer';
import StampContainerList from './components/StampContainerList';
import StampPcdInformation from './components/StampPcdInformation';
import StampSacInformation from './components/StampSacInformation';
import { useLoading } from 'hooks/useLoading';
import PublicService from 'services/PublicService';
//import { v4 as uuidv4 } from 'uuid';
import StampQrCodeContainer from './components/StampQrCodeContainer';
import ExcursionPublicDetails404 from 'features/ExcursionPublicDetailsPage/components/ExcursionPublicDetails404';

const ExcursionPublicStampPage: React.FC = () => {
  const { openLoading, closeLoading } = useLoading();
  const [excursion, setExcursion] = useState<any>();
  const [excursionId, setExcursionId] = useState<number | null>(null);
  const [excursionStampId, setExcursionStampId] = useState<string>('');
  const [page404, setPage404] = useState<boolean>(false);
  const [canceled, setCanceled] = useState<boolean>(false);
  const originURL = window.location.origin;
  //const [accessNumber, setAccessNumber] = useState<string>('');

  // useEffect(() => {
  //   const uuid = uuidv4();
  //   const formattedAccessNumber = uuid;
  //   setAccessNumber(formattedAccessNumber);
  // }, []);

  // const replaceIdUrlToAccessNumber = () => {
  //   window.history.replaceState({}, '', `/excursion/excursion-stamp/${accessNumber}`);
  // };

  const fetchExcursion = async () => {
    const excursionIdFromUrl = window.location.pathname.split('/').pop();
    if (!excursionIdFromUrl) return;
    try {
      openLoading();
      const response = await new PublicService().getPublicExcursionStamp(excursionIdFromUrl);
      const data = response;
      if (data && data.status === 'Cancelada') {
        setExcursion(null);
        setCanceled(true);
      } else {
        setExcursion(data);
        setExcursionStampId(data.id_consulta);
        if (data && data.id) {
          setExcursionId(data.id);
        } else {
          console.error('data.id is undefined');
          setExcursionId(null); // Set a default value or empty string
        }
        console.log('data', data);
      }
    } catch (error) {
      console.error(error);
      setExcursionId(null);
      setPage404(true);
    } finally {
      closeLoading();
    }
  };

  const preparingToPDF = () => {
    openLoading();
    import('html2canvas')
      .then(({ default: html2canvas }) => {
        import('jspdf')
          .then(({ jsPDF }) => {
            const element = document.querySelector('.stamp-container') as HTMLElement;
            const noticeElement = document.querySelector('#pdf-notice-container') as HTMLElement;
            if (!element || !noticeElement) {
              console.error('Elemento do selo ou do aviso não encontrado.');
              closeLoading();
              return;
            }

            html2canvas(element)
              .then(canvas1 => {
                const imgData1 = canvas1.toDataURL('image/png');
                const pdf = new jsPDF({
                  orientation: 'portrait',
                  unit: 'mm',
                  format: 'a4',
                });
                const pageWidth = 210;
                const pageHeight = 297;
                const scale = (pageWidth / canvas1.width) * 1.4;
                const scaledHeight = canvas1.height * scale;
                const yPosition = (pageHeight - scaledHeight) / 2;
                const xPosition = (pageWidth - canvas1.width * scale) / 2;
                pdf.addImage(imgData1, 'PNG', xPosition, yPosition, canvas1.width * scale, scaledHeight);

                html2canvas(noticeElement, {
                  scale: 2,
                  width: noticeElement.offsetWidth,
                  windowWidth: noticeElement.offsetWidth,
                })
                  .then(canvas2 => {
                    const imgData2 = canvas2.toDataURL('image/png');

                    pdf.addPage();

                    const margin = 10;
                    const contentWidthMm = pageWidth - margin * 2;
                    const contentHeightMm = pageHeight - margin * 2;
                    const imgRatio = canvas2.width / canvas2.height;
                    let finalImgWidthMm = contentWidthMm;
                    let finalImgHeightMm = contentWidthMm / imgRatio;

                    if (finalImgHeightMm > contentHeightMm) {
                      finalImgHeightMm = contentHeightMm;
                      finalImgWidthMm = contentHeightMm * imgRatio;
                    }

                    const x = margin + (contentWidthMm - finalImgWidthMm) / 2;
                    const y = margin + (contentHeightMm - finalImgHeightMm) / 2;

                    pdf.addImage(imgData2, 'PNG', x, y, finalImgWidthMm, finalImgHeightMm);

                    pdf.save('selo-de-acesso-a-porto-seguro.pdf');
                    closeLoading();
                  })
                  .catch(err => {
                    console.error('Erro ao renderizar a página de aviso (canvas 2):', err);
                    closeLoading();
                  });
              })
              .catch(err => {
                console.error('Erro ao renderizar a página do selo (canvas 1):', err);
                closeLoading();
              });
          })
          .catch(() => {
            closeLoading();
          });
      })
      .catch(() => {
        closeLoading();
      });
  };

  useEffect(() => {
    fetchExcursion();
    //replaceIdUrlToAccessNumber();
    preparingToPDF();
  }, [excursionId]);

  return (
    <>
      {excursion && (
        <>
          <PDFButtonContainer>
            <PDFButton buttonType="primary" onClick={preparingToPDF}>
              Download em PDF
            </PDFButton>{' '}
          </PDFButtonContainer>{' '}
          <Container className="stamp-container">
            <ContainerTitle>Selo de Acesso a Porto Seguro</ContainerTitle>
            <StampContainer
              hasPCD={excursion?.transport?.has_pcd}
              centralAccess={excursion?.central_access ? 'Sim' : 'Não'}
              AccessNumber={(() => {
                const baseNumber = excursionId ? Math.abs(excursionId) % 100000 : 0;
                const letter = String.fromCharCode(65 + Math.floor(baseNumber / 100000));
                const number = (baseNumber % 100000).toString().padStart(5, '0');
                return `${letter}${number}`;
              })()}
            />
            <StampContainerList
              information={[
                {
                  name: excursion?.organizer?.name,
                  vehicle: excursion?.transport?.vehicle_type,
                  plate: excursion?.transport?.vehicle_plate
                    ? `${excursion.transport.vehicle_plate.slice(0, 3)}-${excursion.transport.vehicle_plate.slice(3)}`
                    : '',
                  period: excursion?.start_date
                    ? `${new Date(excursion.start_date.split('T')[0] + 'T12:00:00').toLocaleDateString(
                        'pt-BR'
                      )} - ${new Date(excursion.end_date.split('T')[0] + 'T12:00:00').toLocaleDateString('pt-BR')}`
                    : '',
                },
              ]}
            />
            <StampPcdInformation visible={excursion?.transport?.has_pcd} />
            <StampQrCodeContainer value={`${originURL}/public/excursion-details/${excursionStampId}`} />
            <StampSacInformation visible={true} />
          </Container>
          <div
            id="pdf-notice-container"
            style={{
              position: 'absolute',
              left: '-9999px',
              top: 'auto',

              width: '794px',
              padding: '20px',
              boxSizing: 'border-box',
              background: '#fff',
              color: '#000',
              fontFamily: 'Arial, sans-serif',
              fontSize: '11pt',
              lineHeight: '1.4',

              border: '2px solid black',
              boxShadow: '4px 4px 8px rgba(0,0,0,0.3)',
            }}>
            <h2
              style={{
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '16pt',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '1px solid black',
              }}>
              AVISO IMPORTANTE - EXCURSÕES E TRANSPORTE TURÍSTICO
            </h2>

            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                marginBottom: '15px',
              }}>
              <tbody>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      padding: '10px',
                      textAlign: 'justify',
                    }}>
                    Conforme a <b>Lei Municipal n° 1.402/2017 (art. 7°, §2°)</b>, o{' '}
                    <b>Decreto nº 13.586/2022 (art. 5º, parágrafo único, e art. 6°)</b> e o{' '}
                    <b>Decreto n° 14.679/2023 (art. 7°, parágrafo único)</b>, é{' '}
                    <span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
                      proibida a circulação de{' '}
                      <span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
                        ÔNIBUS no centro da cidade, tão somente para embarque e desembarque no hotel. Proibido
                        estacionar ÔNIBUS de turismo em vias e logradouros públicos.
                      </span>{' '}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                marginBottom: '15px',
              }}>
              <tbody>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      padding: '10px',
                      textAlign: 'justify',
                    }}>
                    Após o <b>embarque ou desembarque de passageiros</b>, os ônibus devem seguir para{' '}
                    <b>o estacionamento da hospedagem, estacionamento público</b>, ou{' '}
                    <b>locais regulamentados pelo Poder Executivo.</b>
                  </td>
                </tr>
              </tbody>
            </table>

            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                marginBottom: '15px',
              }}>
              <tbody>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      padding: '10px',
                      textAlign: 'justify',
                    }}>
                    De acordo com a <b>Lei Municipal nº 1.097/2013 (art. 4º, parágrafo único)</b>, o{' '}
                    <b>Guia de Turismo</b> deve portar
                    <b>crachá emitido pelo Ministério do Turismo</b>, garantindo a{' '}
                    <b>identificação e regularidade profissional.</b>
                    <br />
                    <br />
                    <b>
                      Nas visitas a atrativos turísticos do município é obrigatória a presença de Guia de Turismo
                      Regional Bahia
                    </b>
                    , devidamente credenciado no <b>CADASTUR</b>.
                  </td>
                </tr>
              </tbody>
            </table>

            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
              }}>
              <tbody>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      padding: '10px',
                      textAlign: 'justify',
                    }}>
                    O descumprimento das normas implicará nas{' '}
                    <b>penalidades previstas na legislação municipal vigente.</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}

      {page404 && (
        <ExcursionPublicDetails404
          title="Excursão não encontrada"
          message="A excursão que você está tentando acessar não foi encontrada."
        />
      )}

      {canceled && (
        <ExcursionPublicDetails404
          title="Excursão cancelada"
          message="O selo é inválido devido ao cancelamento da excursão"
        />
      )}
    </>
  );
};

export default ExcursionPublicStampPage;
